var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharetright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.46501 17.4854L9.95001 9.00035L1.46501 0.51535L0.0500126 1.92935L7.12201 9.00035L0.0500126 16.0714L1.46501 17.4854Z",
    fill: "#2E3A59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharetright);
export default __webpack_public_path__ + "static/media/charetright.cd3dae414ab5abee22be841b1a06ee70.svg";
export { ForwardRef as ReactComponent };